import { Icons } from '@cast/design-system';

import { useCurrentOrganizationId } from '@cast/infrastructure-organization';
import { usePath } from '@cast/utils';

import { buildDboRoute, DboRoute } from 'features/db-optimization/v2/routes';

import { useDboSidebarV2 } from 'features/db-optimization/v2/hooks/useDboSidebar';
import { SidebarItem } from '../../../_components/SidebarItem';
import { SidebarLayout } from '../../../_components/SidebarLayout';
import { SidebarSection } from '../../../_components/SidebarSection';
import { DatabaseNavItems } from './_components/DatabaseNavItemsSection';
import { ServerNavItems } from './_components/ServerNavItemsSection';
import { SidebarSectionErrorBoundary } from './_components/SidebarSectionErrorBoundary';

export const DboSidebarV2 = () => {
  const organizationId = useCurrentOrganizationId();

  const {
    activeServer,
    allInstances,
    loadingServers,
    loadingServersError,
    isOptimized,
  } = useDboSidebarV2();

  const overviewUrl = usePath(() => buildDboRoute(DboRoute.OVERVIEW));

  return (
    <SidebarLayout
      title="Database"
      subtitle="Monitor & optimize"
      icon={
        <Icons.CastDatabaseOptimization
          variant="preset"
          weight="light"
          size={24}
        />
      }
    >
      <SidebarSection title="Organization">
        <SidebarItem title="Overview" url={overviewUrl} />
      </SidebarSection>
      <SidebarSectionErrorBoundary>
        <ServerNavItems
          activeServer={activeServer}
          isOptimized={isOptimized}
          instances={allInstances}
          isLoading={loadingServers}
          error={loadingServersError}
        />
      </SidebarSectionErrorBoundary>
      {isOptimized ? (
        <SidebarSectionErrorBoundary>
          <DatabaseNavItems
            organizationId={organizationId}
            isLoadingInstance={loadingServers}
            instanceError={loadingServersError}
          />
        </SidebarSectionErrorBoundary>
      ) : null}
    </SidebarLayout>
  );
};
